






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaOpenlog} from '@/model/resource/CargaOpenlog'
import {InputCargaOpenlogSchema} from '@/schema/resource/CargaOpenlog/InputCargaOpenlogSchema'

@Component
export default class PersistCargaOpenlogView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaOpenlogSchema()
  cargaOpenlog = new CargaOpenlog()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaOpenlog.getCargaOpenlog(id)
    }

    $.await.done('getCargaOpenlog')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaOpenlog.persistCargaOpenlog()
    await Helper.successAndPush('system.success.persist', '/carga-openlog/list')
  }
}
